import axios from 'axios';

const api = () => window.store.event_backend_api;

// A file reaching a member's list is always a personal grant, so the member is
// in member_ids; anyone beside them keeps the file alive.
export const othersOn = (resource, memberId) =>
  (resource.access?.member_ids || []).filter((id) => id !== memberId);

export const isSoleRecipient = (resource, memberId) => othersOn(resource, memberId).length === 0;

/** Deletes a file only this member holds; otherwise takes this member off it. */
export const removeMemberResource = async (resource, memberId) => {
  if (isSoleRecipient(resource, memberId)) {
    await axios.post(`${api()}/media-items/delete`, {
      resources: [{ media_id: resource.id, session_id: resource.session_id }],
      type: 'global_resources',
    });
    return;
  }

  // Dropped from both lists: staying named while not a recipient would keep
  // the file against this member's count without it being theirs.
  const remaining = othersOn(resource, memberId);
  await axios.put(`${api()}/resources/${resource.id}/access`, {
    all_participants: false,
    member_ids: remaining,
    uploaded_for_user_ids: remaining,
  });
};
